import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineStorageTourService } from 'src/app/pages/immo-ip/placer/tour-view/offline-storage/offline-storage-tour.service';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'immo-ip-placer-subproject-search',
  templateUrl: './immo-ip-placer-subproject-search.component.html',
  styleUrls: ['./immo-ip-placer-subproject-search.component.scss']
})
export class ImmoIPPlacerSubProjectSearchComponent implements OnInit {
  private static readonly LOCAL_STORAGE_KEY = 'installerSearchProjectId';

  projectId: number;
  loading: boolean = false;

  constructor(
    private offlineStorageTourService: OfflineStorageTourService,
    private snackService: SnackService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const storedProjectId = localStorage.getItem(
      ImmoIPPlacerSubProjectSearchComponent.LOCAL_STORAGE_KEY
    );
    if (storedProjectId != null) {
      this.projectId = Number(storedProjectId);
    }
  }

  search(): void {
    this.loading = true;
    localStorage.setItem(
      ImmoIPPlacerSubProjectSearchComponent.LOCAL_STORAGE_KEY,
      this.projectId.toString()
    );
    this.offlineStorageTourService
      .getProjectToTour(this.projectId)
      .then(res => {
        if (res != null) {
          if (res.discriminator === 'DateStringAndSubProject') {
            this.router.navigate([
              'ip-installateur',
              'opdracht',
              res.dateString,
              res.subProjectId.toString()
            ]);
          } else {
            this.router.navigate([
              'ip-installateur',
              'opdracht-andere-toer',
              res.projectId
            ]);
          }
        }
      })
      .catch(err => {
        if (err.status === 404) {
          this.snackService.showError(`Job #${this.projectId} niet gevonden`);
        }
      })
      .finally(() => (this.loading = false));
  }
}
